<template>
    <el-dialog
        title="历史采集数据"
        :model-value="modelValue"
        top="10vh"
        width="90vw"
        @open="dialogOpen"
        @close="closed"
        :close-on-click-modal="false"
    >
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
            <!-- <el-button @click="handleExport" :icon="Upload">详细数据导出</el-button> -->
        </div>
        <div class="tool-box">
            <div class="search-box">
                <el-date-picker
                    v-model="queryForms.date_range"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    style="margin-right: 10px"
                    :default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 2, 1, 23, 59, 59)]"
                />
                <el-button type="primary" :icon="Search" plain @click="getRecordData">搜索</el-button>
                <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
            </div>
        </div>
        <el-table :data="table_data" border v-loading="tableLoading" stripe style="height: 55vh">
            <el-table-column label="上传时间" prop="ts" min-width="160" align="center"></el-table-column>
            <!-- <el-table-column label="ICCID" min-width="200" align="center">
                <template #default="{ row }">{{ row?.iccid }}</template>
            </el-table-column> -->
            <el-table-column label="IMEI" min-width="150" align="center">
                <template #default="{ row }">{{ row?.imei }}</template>
            </el-table-column>
            <el-table-column label="累计正向流量" min-width="150" align="center">
                <template #default="{ row }">{{ row?.positive }}</template>
            </el-table-column>
            <el-table-column label="累计反向流量" min-width="150" align="center">
                <template #default="{ row }">{{ row?.reverse }}</template>
            </el-table-column>
            <el-table-column label="电压(V)" min-width="150" align="center">
                <template #default="{ row }">{{ row?.voltage }}</template>
            </el-table-column>
            <el-table-column label="入水温度(℃)" min-width="150" align="center">
                <template #default="{ row }">{{ row?.temp1 }}</template>
            </el-table-column>
            <el-table-column label="出水温度(℃)" min-width="150" align="center">
                <template #default="{ row }">{{ row?.temp2 }}</template>
            </el-table-column>
            <el-table-column label="信号强度" prop="csq">
                <template #default="{ row }">
                    <div class="signal-box" style="display: flex; align-items: center; justify-content: center">
                        <span class="num">{{ row.csq }}</span>
                        <div class="signal">
                            <span
                                v-for="num of 5"
                                class="bar"
                                :key="num"
                                :class="['bar' + num, num <= Math.floor(row.csq / 6) ? 'active' : '']"
                            ></span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="运行天数" min-width="150" align="center">
                <template #default="{ row }">{{ row?.rundays }}</template>
            </el-table-column>
            <el-table-column label="运行小时数" min-width="150" align="center">
                <template #default="{ row }">{{ row?.runHours }}</template>
            </el-table-column>
            <el-table-column label="运行分钟数" min-width="150" align="center">
                <template #default="{ row }">{{ row?.runminutes }}</template>
            </el-table-column>
            <el-table-column label="瞬间流量" min-width="150" align="center">
                <template #default="{ row }">{{ row?.momenttraffic }}</template>
            </el-table-column>
            <el-table-column label="当前热量" min-width="150" align="center">
                <template #default="{ row }">{{ row?.heat }}</template>
            </el-table-column>
            <el-table-column label="当前冷量" width="100px" align="center">
                <template #default="{ row }">{{ row?.cool }}</template>
            </el-table-column>
            <el-table-column label="热功率" prop="devtype" min-width="160" align="center">
                <template #default="{ row }">{{ row?.heatpower }}</template>
            </el-table-column>
            <el-table-column label="空管报警" min-width="160" align="center">
                <template #default="{ row }">
                    <el-tag type="warning">{{ ['正常', '气泡报警', '空管报警']?.[row?.airtraffic] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="低压报警" min-width="160" align="center">
                <template #default="{ row }">
                    <el-tag type="warning">{{ ['正常', '低压报警']?.[row?.lowpressure] }}</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="table_data.length > 0"
            class="elPagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryForms.page"
            :page-size="queryForms.page_size"
            :page-sizes="[50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
        />
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, ref, reactive } from 'vue'
import { getDeviceListReport } from '@/api/heat_meter/devicePoint.js'
import { Refresh, Search, Upload } from '@element-plus/icons'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import { lockOptions, speed, run_mode } from '@/constant/index.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    deviceDetail: {
        type: Object,
        default: () => ({})
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
// 弹窗打开
function dialogOpen() {
    getRecordData()
}
const devType = {
    1: '烟感',
    2: '燃气',
    3: '紧急求助',
    4: '水浸',
    5: '门磁',
    6: '红外感应',
    7: '声光报警器',
    8: 'CO传感器',
    9: '温湿度传感器',
    10: '温度传感器',
    11: '湿度传感器',
    12: '震动传感器',
    13: '位移传感器',
    14: '压力传感器',
    15: '烟雾+温湿度',
    16: '断电报警器',
    17: '开关量转换器',
    18: '433无线网关',
    19: '白蚁检测器',
    20: '四合一烟感',
    21: '单键定位胸牌',
    22: '倾角检测仪',
    23: '倾角+震动检测仪',
    24: '烟雾+温度+CO复合探测器',
    25: '人体存在探测器(雷达)',
    26: '跌倒探测器（雷达）',
    27: '睡眠检测仪（雷达）',
    28: '温湿度+甲醛检测',
    29: '吸烟报警器',
    30: '无线手动报警按钮',
    100: 'RT-SN101-N串口模块',
    101: 'RT-SN102-N串口模块',
    103: '盲板检测',
    104: '家用锅炉房专用CO传感器',
    105: '供暖专用温度传感器'
}
const statusMap = {
    1: '心跳',
    2: '报警',
    3: '报警恢复',
    4: '防拆报警',
    5: '防拆报警恢复',
    6: '电池低压',
    7: '电池电压恢复',
    10: '自检（按键上报）',
    14: '探测器故障',
    18: '交流掉电',
    19: '交流电恢复',
    20: '布防',
    21: '撤防'
}
const statusList = [
    { bit: 0, label: '报警状态', type: 'danger' },
    { bit: 1, label: '保留', type: 'danger' },
    { bit: 2, label: '防拆状态', type: 'warning' },
    { bit: 3, label: '电池低压', type: 'warning' },
    { bit: 4, label: '保留', type: 'danger' },
    { bit: 5, label: '传感器故障', type: 'danger' },
    { bit: 6, label: '交流掉电', type: 'warning' },
    { bit: 7, label: '撤防状态', type: 'info' }
]

function getTimeByPeriod(period) {
    const key = `tStage${period}`
    return props.deviceDetail.hasOwnProperty(key) ? props.deviceDetail[key] : '--'
}
// 表格数据
const table_data = ref([])
const tableLoading = ref(false)
function getRecordData() {
    tableLoading.value = true
    const params = { ...queryForms.value }
    params.device_id = props.deviceDetail.id
    if (params.date_range) {
        params.start_time = params.date_range[0]
        params.end_time = params.date_range[1]
    }
    delete params.date_range
    getDeviceListReport(params).then((data) => {
        console.log('🚀 ~ getRecordData ~ data:', data)
        if (data.lists.length > 0) {
            table_data.value = data.lists
            total.value = data.total
        } else {
            table_data.value = []
            total.value = 0
        }
        tableLoading.value = false
    })
}

const queryForms = ref({
    date_range: null,
    page: 1,
    page_size: 50
})
const total = ref(0)
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    getRecordData()
}
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getRecordData()
}

// 重置
const resetQueryForm = () => {
    queryForms.value = {
        date_range: null,
        page: 1,
        page_size: 50
    }
    total.value = 0
    getRecordData()
}

// 详细数据导出
function handleExport() {
    ElMessageBox.confirm('确定导出当前日期范围的设备状态数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let list = []
            const params = {
                page: 1,
                page_size: 10000,
                id: props.deviceDetail.id
            }
            if (queryForms.value.date_range) {
                params.start_time = queryForms.value.date_range[0]
                params.end_time = queryForms.value.date_range[1]
            }
            const { lists } = await getReportData(params)
            list = lists
            if (list.length <= 0) {
                loading.close()
                return ElMessage.error('没有数据可导出')
            }

            const workbook = new Exceljs.Workbook()
            workbook.created = new Date()
            workbook.modified = new Date()
            const worksheet = workbook.addWorksheet('设备状态数据', {
                properties: { defaultRowHeight: 22 },
                pageSetup: { horizontalCentered: true }
            })

            // 严格按照表格列顺序定义导出字段，无任何多余字段
            worksheet.columns = [
                { header: '上传时间', key: 'update_time', width: 22 },
                { header: '名称', key: 'name', width: 20 },
                { header: 'IMEI', key: 'IMEI', width: 20 },
                { header: 'ICCID', key: 'ICCID', width: 23 },
                { header: '运行状态', key: 'run_status', width: 12 },
                { header: '信号强度', key: 'signal', width: 15 },
                { header: '开关状态', key: 'switch', width: 12 },
                { header: '运行模式', key: 'run_mode', width: 12 },
                { header: '风速状态', key: 'wind_speed', width: 12 },
                { header: '实时温度', key: 'temp', width: 15 },
                { header: '设定温度', key: 'set_temp', width: 15 },
                { header: '各时段高速风累计时长（分钟）', key: 'high_time', width: 30 },
                { header: '各时段中速风累计时长（分钟）', key: 'mid_time', width: 30 },
                { header: '各时段低速风累计时长（分钟）', key: 'low_time', width: 30 },
                { header: '时间区间', key: 'time_period', width: 18 }
            ]

            // 数据映射完全匹配表格显示逻辑
            worksheet.addRows(
                list.map((row) => {
                    return {
                        IMEI: props.deviceDetail.IMEI,
                        name: props.deviceDetail.name,
                        ICCID: props.deviceDetail.ICCID,
                        update_time: row.update_time || '',
                        signal: row.signal || '',
                        temp: row.temp ?? '',
                        set_temp: row.set_temp ?? '',
                        humidity: row.humidity ?? '',
                        run_status: row.run_status === 1 ? '正常' : '故障',
                        lock: lockOptions.find((item) => item.value === row.lock)?.label || '',
                        switch: row.switch === 1 ? '开' : '关',
                        wind_speed: speed.find((item) => item.value === row.set_wind_speed)?.label || '',
                        run_mode: run_mode.find((item) => item.value === row.run_mode)?.label || '',
                        low_time: row.low_time || '0',
                        mid_time: row.mid_time || '0',
                        high_time: row.high_time || '0',
                        switch_timestamp: row.switch_timestamp || '',
                        time_period: getTimeByPeriod(row.time_period)
                    }
                })
            )

            // 表头样式优化
            const headerRow = worksheet.getRow(1)
            headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
            headerRow.font = { bold: true }

            // 导出文件
            await workbook.xlsx.writeBuffer().then((buffer) => {
                const date = new Date()
                const [year, month, day, hour, minutes, seconds] = [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0'),
                    String(date.getHours()).padStart(2, '0'),
                    String(date.getMinutes()).padStart(2, '0'),
                    String(date.getSeconds()).padStart(2, '0')
                ]
                const fileName = `温控器设备状态数据_${year}${month}${day}_${hour}${minutes}${seconds}.xlsx`
                FileSaver.saveAs(new Blob([buffer]), fileName)
            })

            loading.close()
            ElMessage.success('导出成功！')
        })
        .catch(() => {})
}

// 关闭
function closed() {
    table_data.value = []
    queryForms.value = {
        date_range: null,
        page: 1,
        page_size: 50
    }
    emits('update:modelValue', false)
}
</script>

<style scoped>
.tool-box {
    display: flex;
}
.tool-box .search-box {
    display: flex;
    align-items: center;
}
</style>
